/**
 * The page's latest errors (uncaught ones and rejected promises), kept from the app's start so a
 * bug report can say what went wrong before the person wrote (`components/report-bug.tsx`).
 */
const KEPT = 10
const recent: { at: string; message: string }[] = []

function keep(message: string) {
  recent.push({ at: new Date().toISOString(), message: message.slice(0, 500) })
  if (recent.length > KEPT) recent.shift()
}

window.addEventListener("error", (e) => keep(e.error?.stack || e.message))
window.addEventListener("unhandledrejection", (e) =>
  keep(e.reason instanceof Error ? e.reason.stack || e.reason.message : String(e.reason))
)

export function recentErrors() {
  return [...recent]
}
